import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import './Cards';

function HeroSection() {

  const scrollToSection = (targetId) => {
    document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className='hero-container'>
      <h1>SCHICLUB BUCH</h1>

      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
          to='/mitgliedsantrag'
        >
          MITGLIED WERDEN
        </Button>

        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={() => scrollToSection("section1")}
        >
          ENTDECKEN <i className='far fa-play-circle' />
        </Button>
      </div>

    </div>
  );
}

export default HeroSection;
